module.exports = __webpack_public_path__ + "img/100.6a631404.svg";